var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouseFill = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.433,
    height: 16.948,
    viewBox: "0 0 18.433 16.948",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house-fill",
    transform: "translate(-0.499 -1.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M9.373,3.589l7.373,7.373v5.169A1.843,1.843,0,0,1,14.9,17.974H3.843A1.843,1.843,0,0,1,2,16.131V10.961Zm6.144-.974v4.3L13.059,4.458V2.614A.614.614,0,0,1,13.673,2H14.9A.614.614,0,0,1,15.516,2.614Z",
    transform: "translate(0.343 0.181)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M8.847,1.567a1.229,1.229,0,0,1,1.737,0l8.168,8.166a.615.615,0,0,1-.87.87L9.716,2.436,1.549,10.6a.615.615,0,1,1-.87-.87Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouseFill);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC40MzMiIGhlaWdodD0iMTYuOTQ4IiB2aWV3Qm94PSIwIDAgMTguNDMzIDE2Ljk0OCI+CiAgPGcgaWQ9ImhvdXNlLWZpbGwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjQ5OSAtMS4yMDcpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzkwMCIgZGF0YS1uYW1lPSJQYXRoIDkwMCIgZD0iTTkuMzczLDMuNTg5bDcuMzczLDcuMzczdjUuMTY5QTEuODQzLDEuODQzLDAsMCwxLDE0LjksMTcuOTc0SDMuODQzQTEuODQzLDEuODQzLDAsMCwxLDIsMTYuMTMxVjEwLjk2MVptNi4xNDQtLjk3NHY0LjNMMTMuMDU5LDQuNDU4VjIuNjE0QS42MTQuNjE0LDAsMCwxLDEzLjY3MywySDE0LjlBLjYxNC42MTQsMCwwLDEsMTUuNTE2LDIuNjE0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4zNDMgMC4xODEpIiBmaWxsPSIjZmZmIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzkwMSIgZGF0YS1uYW1lPSJQYXRoIDkwMSIgZD0iTTguODQ3LDEuNTY3YTEuMjI5LDEuMjI5LDAsMCwxLDEuNzM3LDBsOC4xNjgsOC4xNjZhLjYxNS42MTUsMCwwLDEtLjg3Ljg3TDkuNzE2LDIuNDM2LDEuNTQ5LDEwLjZhLjYxNS42MTUsMCwxLDEtLjg3LS44N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogIDwvZz4KPC9zdmc+Cg==";